import { nullable, string, struct } from 'io-ts/Decoder';

import { Id } from './Id';

export const NewRefItem = struct({
	id: nullable(Id),
	name: string,
});
